<template>
  <div class="filter-general">
    <parametrs-list :items.sync="fieldsData.parameters" :parameters="fieldsData.properties"> </parametrs-list>
    <b-field class="apply">
      <edit-button :editOptions="['Apply']" @click="apply()">
        <template>
          <span class="text">{{ $t('button.apply') }}</span>
        </template>
      </edit-button>
    </b-field>
  </div>
</template>
<script>
import EditButton from '@/components/EditButton'
import ParametrsList from '@/components/ParametrsList'

export default {
  name: 'DashboardFilterGeneral',
  components: {
    ParametrsList,
    EditButton
  },
  props: {
    items: {
      type: Object,
      default() {
        return {}
      }
    },
    configs: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      fieldsData: {}
    }
  },
  mounted() {
    this.rerender()
  },
  watch: {
    configs: {
      deep: true,
      immediate: true,
      handler: 'rerender'
    }
  },
  methods: {
    rerender() {
      if (this.configs.parameters['Display 2nd condition']) {
        this.fieldsData = { ...this.items }
      } else {
        const parameters = {}
        for (const [key, value] of Object.entries(this.items.parameters)) {
          if (key != 'and/or' && key != '2nd condition' && key != '2nd value') {
            parameters[key] = value
          }
        }
        const properties = []
        for (const item of this.items.properties) {
          if (item.name != 'and/or' && item.name != '2nd condition' && item.name != '2nd value') {
            properties.push(item)
          }
        }
        this.fieldsData = {
          parameters,
          properties
        }
      }
      this.$forceUpdate()
    },
    apply() {
      this.$emit('apply', { parameters: this.fieldsData.parameters })
    }
  }
}
</script>

<style lang="scss">
.filter-general {
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 100%;
  height: 100%;
  .parametrs-list {
    margin-bottom: 0.75rem;
    min-width: auto;
    .field {
      .field-body {
        flex-grow: 5;
      }
      .field-label {
        // min-width: 8rem;
        padding-top: 0;
        width: 100%;
        .label {
          text-align: right;
          width: 100%;
          // min-width: 6.25rem;
        }
      }
    }
  }
  .apply {
    justify-content: right;
    display: flex;
  }
}
</style>
